export default __webpack_public_path__ + "static/media/rightArrowHover.a7a9adcd.png";